import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const LockIcon = memo(({ className, style }: SVGProps) => {
  return (
    <svg className={className} style={style} viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5 13.2c-.656 0-1.188.537-1.188 1.2V18c0 .663.532 1.2 1.188 1.2.656 0 1.188-.537 1.188-1.2v-3.6c0-.663-.532-1.2-1.188-1.2zm5.938-4.8V6c0-3.314-2.659-6-5.938-6-3.28 0-5.938 2.686-5.938 6v2.4C4.595 8.4 3 10.012 3 12v8.4C3 22.388 4.595 24 6.563 24h11.875C20.404 24 22 22.388 22 20.4V12c0-1.988-1.595-3.6-3.563-3.6zM8.938 6c0-1.988 1.594-3.6 3.562-3.6 1.968 0 3.563 1.612 3.563 3.6v2.4H8.938V6zm10.687 14.4c0 .663-.532 1.2-1.188 1.2H6.563a1.194 1.194 0 0 1-1.187-1.2V12c0-.663.532-1.2 1.188-1.2h11.875c.655 0 1.187.537 1.187 1.2v8.4z"
        fillRule="evenodd"
      />
    </svg>
  )
})
